import { render } from "./people.vue?vue&type=template&id=1c0d3274"
import script from "./people.vue?vue&type=script&lang=js"
export * from "./people.vue?vue&type=script&lang=js"

import "./people.vue?vue&type=style&index=0&id=1c0d3274&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__